import React from 'react';
import TeachItem from './TeachItem';

const AccountContent = ({acc}) => {
  return (
    <>
      { acc &&
        <div className='row' style={{'margin':'50px 50px 50px 50px'}}>
          <div className='col s6'>
            {acc.filter((v,i)=>i%2===0).map(v=>(<div key={v.uidNumber}> <TeachItem account={v} /></div>))}
          </div>
          <div className='col s6'>
            {acc.filter((v,i)=>i%2===1).map(v=>(<div key={v.uidNumber}> <TeachItem account={v} /></div>))}
          </div>
        </div>
      }
    </>
  );
};

export default AccountContent;
